import { styled } from '@mui/material';
import Typography from '@mui/material/Typography';
import { colors } from '@rumblefish/ui';
import { CompaniesCarousel } from '@rumblefish/ui/src/components/Rumblefish23Theme';
import { whoWeAreData } from '../homePageDesign23/WhoWeAre/whoWeAre.data';
import pplPhoto from '../../public/webp/fromJPG/ppl.webp';
import teamPhoto from '../../public/webp/fromJPG/team/Team.webp';
import rickPhoto from '../../public/webp/fromPNG/rick.webp';
import runePhoto from '../../public/webp/fromPNG/rune.webp';
import person4 from '../../public/webp/fromPNG/team/Karolina.webp';
import person2 from '../../public/webp/fromPNG/team/Marcin.webp';
import marekPhoto from '../../public/webp/fromPNG/team/Marek.webp';
import person3 from '../../public/webp/fromPNG/team/Sylwia.webp';

const JoinThemStyled = styled(Typography)(
  ({ theme: { spacing } }) => `
  width: 100%;
  text-align: center;
  margin-top: ${spacing(3)};
  margin-bottom: ${spacing(3)};
`
);

const JoinThem = () => {
  return (
    <JoinThemStyled
      color={colors.blackText}
      variant="body2"
      fontWeight="bold"
      fontSize="1rem">
      Join them!
    </JoinThemStyled>
  );
};

export const paragraphOne = {
  text: [
    'We were established in 2017 and since then we’ve helped dozens of entrepreneurs reach their business goals through state-of-the-art technology.',
    JoinThem,
    CompaniesCarousel,
  ],
  img: {
    src: pplPhoto,
    width: 550,
    height: 366,
  },
};

export const paragraphTwo = {
  text: [
    'We think outside the box to find the best possible ways to make your business idea a reality. Our unique skillset and focus on continuous knowledge gaining are what makes us different. Rumble Fish is your trusted end-to-end software development partner - <b>we take care of technology so that you can focus on your business.</b>',
  ],
  img: {
    src: rickPhoto,
    width: 545,
    height: 515,
  },
};

export const marekDetails = {
  personName: 'Marek Kowalski',
  personPosition: 'CEO & CTO & Founder of Rumble Fish',
  text: 'As Rumble Fish CTO, I am responsible for ensuring the highest quality of our tech stack and training developers. My professional goal is to help customers unlock the power of software through the most innovative technology and solutions that are used in our projects.',
  img: marekPhoto,
};

export const runeDetails = {
  personName: 'Rune Christensen',
  personPosition: 'Founder and CEO of MakerDAO',
  text: 'Rumble Fish performed beyond our wildest dreams. Their skilled developers helped us improve our exchange platform. The engineers were responsible for carrying out development work on the platform, as well as some lesser-known components of the MakerDAO ecosystem: Oasis Direct and Eth2Dai. Their knowledge and expertise allowed us to grow up even faster. They are quick to respond and always have the best solution.',
  img: runePhoto,
};

export const TeamData = {
  counters: whoWeAreData.counters,

  image1: teamPhoto,

  gallery: [
    {
      img: marekPhoto,
      name: 'Marek',
      position: 'CEO / CTO',
      linkedIn: 'https://www.linkedin.com/in/marek-kowalski-797a438/',
    },
    {
      img: person2,
      name: 'Marcin',
      position: 'Co-CTO',
      linkedIn: 'https://www.linkedin.com/in/marcin-misiorek-1ba824a0/',
    },
    {
      img: person3,
      name: 'Sylwia',
      position: 'Head of Growth',
      linkedIn:
        'https://www.linkedin.com/in/sylwia-bien-marketing-lead-generation/',
    },
    {
      img: person4,
      name: 'Karolina',
      position: 'HR Manager',
      linkedIn:
        'https://www.linkedin.com/in/karolina-kubas-stachowska-253ba4b3/',
    },
  ],
};
